import React, { useState } from "react";
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap";
import Loader from "../common/Spinner";
import godrejDarkLogo from "../../assets/images/godrej.svg";
const DepartmentSelection = ({ users, token, onDeptSelected, onBack }) => {
  const [selectedDeptId, setSelectedDeptId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDeptId) {
      setError("Please select a department");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const selectedUser = users.find(user => user.DeptId === selectedDeptId);
      if (selectedUser) {
        onDeptSelected({ UserData: selectedUser, Token: token });
      } else {
        setError("Invalid department selection.");
      }
    } catch (err) {
      setError("Department selection failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}
      
      {/* Header - Same as AccessCode */}
      <div className="d-flex logoHeader">
        <img src={godrejDarkLogo} alt="Godrej Enterprise Logo" />
        <span className="headerLink">Godrej Enterprises Group</span>
      </div>

      {/* Department Selection Content - Centered */}
      <Container fluid className="accesscode-container">
        <Row className="justify-content-center align-items-center h-100">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Card className="accesscode-card shadow">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <h2 className="accesscode-title">Commercial Legal Website</h2>
                  <p className="accesscode-subtitle">Department Selection</p>
                </div>

                <Form onSubmit={handleSubmit}>
                  <div className="text-center mb-4">
                    <p className="accesscode-instruction">
                      Multiple departments found for your account. Please select the department you want to access.
                    </p>
                  </div>

                  {error && (
                    <div className="accesscode-error mb-3">
                      <div className="accesscode-error-header">Selection Failed</div>
                      <div className="accesscode-error-body">{error}</div>
                    </div>
                  )}

                  <div className="mb-4">
                    <Form.Label className="accesscode-label">Select Department:</Form.Label>
                    {users.map((user) => (
                      <div key={user.DeptId} className="accesscode-radio mb-2">
                        <Form.Check
                          type="radio"
                          id={`dept-${user.DeptId}`}
                          name="department"
                          value={user.DeptId}
                          checked={selectedDeptId === user.DeptId}
                          onChange={(e) => setSelectedDeptId(e.target.value)}
                          label={
                            <div>
                              <strong>Dept ID: {user.DeptId}
                              </strong>
                              <div style={{ color: '#6c757d', fontSize: '0.9em', marginTop: '2px' }}>
                               {user.DeptId} -  {user.DeptName}
                              </div>
                            </div>
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div className="d-grid mb-3">
                    <Button 
                      type="submit"
                      variant="success"
                      className="accesscode-submit-btn"
                      disabled={loading || !selectedDeptId}
                      size="lg"
                    >
                      {loading ? "Processing..." : "Continue"}
                    </Button>
                  </div>

                  {onBack && (
                    <div className="text-center">
                      <Button 
                        variant="link" 
                        onClick={onBack}
                        className="accesscode-back-btn"
                      >
                        Back to Login
                      </Button>
                    </div>
                  )}
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DepartmentSelection;